<script setup lang="ts">
import { i18n } from '@apps/main/modules/localization/localizationSetup';

import { AppSingleSelect } from '@libs/ui';

import type { AvailableItineraryActivitySegment } from '../../../models';
import ItineraryTimeline from '../ItineraryTimeline.vue';

import ActivityProductCard from './ActivityProductCard.vue';
import ActivityCardHeader from './ActivityCardHeader.vue';

const { t } = i18n.global;

interface AvailableActivitySegmentProps {
  segment: AvailableItineraryActivitySegment;
  printMode: boolean;
}

const props = defineProps<AvailableActivitySegmentProps>();

interface AvailableActivitySegmentEmits {
  (eventName: 'change-product'): void;
  (eventName: 'remove-activity'): void;
  (eventName: 'show-details'): void;
}

const emit = defineEmits<AvailableActivitySegmentEmits>();
</script>

<template>
  <ItineraryTimeline
    :segment-type="props.segment.segmentType"
    class="available-activity-segment"
  >
    <template #dropdown>
      <AppSingleSelect
        type="primary"
        :selected="{
          id: 1,
          label: t('planner.activity'),
          icon: 'activity',
        }"
        left-side-icon="activity"
        :options="[]"
        disabled
      />
    </template>
    <template #header>
      <ActivityCardHeader
        :print-mode="props.printMode"
        :date="props.segment.date"
        @remove="emit('remove-activity')"
      />
    </template>

    <template #content>
      <ActivityProductCard
        :product-card-data="props.segment.productCardData"
        :print-mode="props.printMode"
        @show-details="emit('show-details')"
        @change-product="emit('change-product')"
      />
    </template>
  </ItineraryTimeline>
</template>
